import type {
  DetectarFichaResponse,
  GenerarGeometriaResponse,
  GenerarRenderRequest,
  GenerarRenderResponse,
  GetGeometriaResponse,
} from '@supernova/shared';
import { apiFetch } from './client.js';

/**
 * Cliente del PROTOTIPO staff-only "de la HP a la geometría": genera plano 2D
 * (DXF+SVG), modelo 3D BIM (IFC) en $0, y —como acción aparte con costo— fotos
 * fotorrealistas y una animación por IA. Endpoints gateados por flag + staff.
 */

export type {
  DetectarFichaResponse,
  GenerarGeometriaResponse,
  GenerarRenderResponse,
  GetGeometriaResponse,
};

/**
 * Detecta (por IA, cacheada) la ficha del edificio de una cotización para
 * PREllenar el modal al abrirlo. Una sola llamada de IA por cotización: si ya
 * estaba detectada, el server la devuelve sin volver a gastar (`cached=true`).
 */
export function detectarFichaGeometria(quoteId: string): Promise<DetectarFichaResponse> {
  return apiFetch<DetectarFichaResponse>(
    `/api/v1/quotes/${quoteId}/geometria/detectar-ficha`,
    { method: 'POST' },
  );
}

/** Encola la generación de la geometría base ($0) para una cotización. */
export function generarGeometria(quoteId: string): Promise<GenerarGeometriaResponse> {
  return apiFetch<GenerarGeometriaResponse>(`/api/v1/quotes/${quoteId}/geometria`, {
    method: 'POST',
  });
}

/** Encola el render por IA (fotos + animación si se pidió). Cuesta. */
export function generarRender(
  quoteId: string,
  body: GenerarRenderRequest,
): Promise<GenerarRenderResponse> {
  return apiFetch<GenerarRenderResponse>(`/api/v1/quotes/${quoteId}/geometria/render`, {
    method: 'POST',
    body,
  });
}

/** Estado + URLs de los artefactos (geometría + fotos/animación). */
export function getGeometria(quoteId: string): Promise<GetGeometriaResponse> {
  return apiFetch<GetGeometriaResponse>(`/api/v1/quotes/${quoteId}/geometria`);
}
